import type { ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import { channelLabel, leadLabel } from '../presentation';
import type { NotificationRule } from '../types';

interface Props {
  rules: NotificationRule[];
  onEdit: (rule: NotificationRule) => void;
}

/** Tabla "Reglas de notificación" del mockup: evento, canal, anticipación y estado,
 *  con edición por fila. En móvil la tabla se desplaza dentro de su tarjeta, como las demás. */
export function RulesCard({ rules, onEdit }: Props): ReactElement {
  const overdue = rules.find((r) => r.code === 'stage.overdue');
  return (
    <div className="card rise d1">
      <div className="ch">
        <h3 id="rules-title">Reglas de notificación</h3>
        <span className="count">por evento</span>
      </div>
      <div className="t-scroll">
        <table className="t" aria-labelledby="rules-title">
          <thead>
            <tr>
              <th>Evento</th>
              <th>Canal</th>
              <th>Anticipación</th>
              <th>Estado</th>
              <th>
                <span className="sr-only">Acciones</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.code}>
                <td>{r.name}</td>
                <td className="dim-mono">{channelLabel(r.channels)}</td>
                <td className="dim-mono">{overdue ? leadLabel(r, overdue) : ''}</td>
                <td>
                  <span className={cn('badge', r.enabled ? 'b-ok' : 'b-mut')}>
                    {r.enabled ? 'Activa' : 'Inactiva'}
                  </span>
                </td>
                <td className="t-act">
                  <button
                    type="button"
                    className="btn mut sm"
                    aria-label={`Editar ${r.name}`}
                    onClick={() => onEdit(r)}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="cb rules-note">
        El aviso en plataforma permanece hasta completar la actividad.
      </p>
    </div>
  );
}
